module.exports = __webpack_public_path__ + "static/media/thumb_triot.9c2106f9.jpg";